import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { chatbotService } from '../../../services/ChatbotService';
import type { ChatbotTrainingExamplesListOptions } from '../chatbotTrainingExamplesListParams';
import { chatbotQueryKeys } from '../chatbotQueryKeys';

export function useChatbotTrainingExamplesQuery(
  chatbotId: string | undefined,
  listOptions: ChatbotTrainingExamplesListOptions,
  enabled = true,
) {
  const { user } = useAuth();
  const resolvedChatbotId = chatbotId?.trim() ?? '';
  const isEnabled = enabled && Boolean(user) && resolvedChatbotId.length > 0;

  return useQuery({
    queryKey: chatbotQueryKeys.trainingExamples(resolvedChatbotId, listOptions),
    enabled: isEnabled,
    queryFn: () =>
      chatbotService.listTrainingExamples(resolvedChatbotId, listOptions),
  });
}
